import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwThanksPageComponent } from './pw-thanks-page.component';



@NgModule({
  declarations: [
    PwThanksPageComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PwThanksPageModule { }
